<template>
    <div class="page-wrapper">
        <div class="page">
            <ul class="page-nav">
                <li><router-link to="/layout/index">首页</router-link></li>
                <li><router-link to="/layout/info-pool?id=4">信息交流</router-link></li>
                <li><router-link :to="`/layout/share-info?id=2&page=${parentPage}`">共享信息</router-link></li>
                <li  v-if="officeName"><router-link :to="parentLink">{{ officeName }}</router-link></li>
                <li class="currentNode"><a>详情</a></li>
            </ul>
            <div class="page-main">
                    <div class="page-main-tp">
                        <div>
                            <div class="dt">
                                <span class="day">{{ publishTime  | traverseDate('day')}}</span>
                                <span class="bias">/</span>
                                <span class="month"><i>{{ publishTime  | traverseDate('month')}}月</i><i></i>{{ publishTime  | traverseDate('year')}}年</span>
                            </div>
                            <div class="dd">共享信息</div>
                        </div>
                        <div class="article-title">
                            <h3>{{ title }}</h3>
                            <p class="subtitle">{{ subTitle }}</p>
                        </div>
                    </div>
                    <div class="page-main-btm content-detail"  v-html="content"></div>
                        <!-- <p>本次研讨会邀请到了农业农村部、国家信息中心、商务部、平谷农业中关村管委会、山东德州、广西南宁等各级、各地方政府相关领导、国内外行业专家、优秀企业代表、会员单位共计130余人现场出席会议。同时，线上直播吸引观众高达5万余人，各界人士通过本次会议进一步了解到数字乡村的国际国内最新技术与发展。</p>
                        <p>研讨会上，农业农村部市场预警专家委员会秘书长、农业农村部农业信息服务技术重点实验室主任许世卫在致辞中指出，数字乡村建设应该说是全方位的数字乡村发展的整体体系建设，是一种针对更好的解决农业能力、技术应对能力的工作，数字乡村建设适应我们当前的需要。</p> -->
                    
                </div>
        </div>
    </div>
</template>

<script>
import {
    getPlolicyDetail,
    getProjectDown
} from '@services/indexService.js'
import { getCookie } from '@/assets/utils/cookie.js'
export default {
    name:"",
    data() {
        return {
            detailId: '',
            title: '',
            subTitle: '',
            accountId: '',
            content: '',
            publishTime: '',
            parentNav: '',
            page: 1,
            parentPage: '',
            officeName: '',
            officeId: '',
            parentLink: '',
        }
    },
    created() {
        this.detailId = this.$route.query.id;
        this.page = this.$route.query.page ?  this.$route.query.page : 1;
        this.parentPage = this.$route.query.parentPage ? this.$route.query.parentPage : 1;
        this.officeName = this.$route.query.officeName;
        this.officeId = this.$route.query.officeId;
        this.parentLink = `/layout/share-info-item?id=2&page=${this.page}&officeId=${this.officeId}`
                            + `&officeName=${this.officeName}&parentPage=${this.parentPage}`;
        this.getPlolicyDetail(this.detailId);
    },
    methods: {
        getPlolicyDetail (id) {
            let params = {
                id: id,
            };
            if (getCookie('accountType')) {
                params.accountType = getCookie('accountType');
            }
            getPlolicyDetail(params).then(res => {
                if (res.Code == 1 && res.Data.length!==0) {
                    this.publishTime = res.Data.UpdateTime;
                    this.title = res.Data.Title;
                    this.subTitle = res.Data.SubTitle;
                    this.content = res.Data.Content;
                    // this.content = res.Data.Content.replace(/<br\/>/g, '');
                    // console.log(this.content)
                } else {
                    this.$message.error(res.Message);
                }
            })
        },
        getProjectDown() {
            let params = {
                id: this.detailId
            };
            getProjectDown(params).then(res => {
                console.log(res);
                if (res.Code == 1 && res.Data.length!==0) {
                    this.downloadUrl = res.Data;
                    window.open(this.downloadUrl, '_blank');
                } else {
                    this.$message.error("访问下载请求失败");
                }
            })
        },
    }
}
</script>

<style src="../../assets/css/articleDetail.css" scoped></style>
<style scoped>
</style>